import { memo } from "react"
import styled from "styled-components"

const ConstrolSafe = styled.div`
  display: flex;
  padding: 0px;
  justify-content: center;
  align-items: center;
`

const IconShine = () => {
  return (
    <ConstrolSafe>
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
        <path
          d="M28.5 1.5L26.61 5.625L22.5 7.5L26.61 9.39L28.5 13.5L30.375 9.39L34.5 7.5L30.375 5.625M13.5 6L9.75 14.25L1.5 18L9.75 21.75L13.5 30L17.25 21.75L25.5 18L17.25 14.25M28.5 22.5L26.61 26.61L22.5 28.5L26.61 30.375L28.5 34.5L30.375 30.375L34.5 28.5L30.375 26.61"
          fill="#7B78E1"
        />
      </svg>
    </ConstrolSafe>
  )
}

export default memo(IconShine)
